import { render, staticRenderFns } from "./SavedDesign.vue?vue&type=template&id=3df64806&scoped=true&"
import script from "./SavedDesign.vue?vue&type=script&lang=js&"
export * from "./SavedDesign.vue?vue&type=script&lang=js&"
import style0 from "./SavedDesign.vue?vue&type=style&index=0&id=3df64806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df64806",
  null
  
)

export default component.exports